/* ═══ MIRIAM LLANTADA · FICHA DE PRODUCTO FÍSICO · CAPÍTULOS ═══
   Sin dependencias ni librerías, compatible con defer. Se inicia por
   instancia, igual que ml-producto.js y ml-pestanas.js, para que el editor de
   temas pueda cargar y descargar la sección sin recargar la página.
   Expone window.MLCapitulos.init(root) y .destroy(root).

   Viene de ../../producto/ml-producto-b-progreso.html, la maqueta aprobada.

   ══════════════════════════════════════════════════════════════════
   QUÉ GOBIERNA, Y QUÉ NO
   ══════════════════════════════════════════════════════════════════
   Gobierna la barra de progreso pegajosa, no los capítulos: los capítulos son
   HTML a sangre y se leen igual con el guion apagado. De la barra hace seis
   cosas, y solo la última hace falta para comprar:

     1 · la enciende al dejar atrás la primera pantalla de capítulos y la
         retira cuando el bloque entero sale por arriba de la ventana —no
         antes: sobre el pie sigue encendida, porque desde el 02/09/2026
         también compra—, y no la enciende nunca si la ficha monta también la
         barra de compra;
     2 · marca el capítulo que se está leyendo y pone su número en el contador;
     3 · mueve la línea de avance según lo leído;
     4 · pone la lista de paradas a desplazarse cuando desborda, y arrastra la
         parada activa a la vista;
     5 · copia el precio y el rótulo del botón cuando cambia la variante, y
         deshabilita el botón cuando la variante elegida está agotada;
     6 · DESTAPA EL BOTÓN Y LE PASA EL CLIC al botón del panel de compra, y en
         móvil enseña la confirmación de que la línea ha entrado.

   Lo sexto es del 02/09/2026 y es lo que convierte esta barra en la única
   forma de comprar que hay en los siete capítulos de la ficha física: medido,
   7386 px de página con UN SOLO sitio donde pulsar, a 435 px del principio.

   ══════════════════════════════════════════════════════════════════
   NI UN LISTENER DE SCROLL, Y NO ES UNA MANÍA
   ══════════════════════════════════════════════════════════════════
   Nueve capítulos, cada uno abriendo con una fotografía a pantalla completa:
   son veinte o treinta pantallas de documento. Un listener de scroll con ese
   recorrido corre a 60 fps mientras alguien baja con el pulgar, y eso en un
   móvil se nota. Aquí despiertan observadores y decide la geometría, que es
   el reparto de assets/ml-producto.js: «el observador avisa; la geometría
   decide, también al arrancar y sin esperar registro».

   El reparto importa por lo que el banco ya vigila en la barra de compra: la
   caja que trae un registro es la de CUANDO SE ENCOLÓ, no la de ahora, y un
   registro que llega tarde diciendo lo contrario de lo que dice la página no
   puede mandar. Así que ningún estado de este archivo se lee de una entrada:
   todas se leen con getBoundingClientRect en el momento de pintar, y las
   entradas solo sirven para saber que hay que volver a mirar.

   ══════════════════════════════════════════════════════════════════
   AQUÍ NO SE CREA NI UNA PROMESA
   ══════════════════════════════════════════════════════════════════
   Las promesas rechazadas sin dueño no rompen nada, no salen por pageerror y
   el navegador —y Clarity— las cuentan como error igual. Costaron el arreglo
   del 26/08/2026 y las vigila la prueba N19. Este archivo no llama a
   startViewTransition, no usa element.animate() —de donde sale .finished, que
   rechaza al cancelarse— y no toca ninguna API que devuelva promesa; scrollTo
   y scrollIntoView no devuelven nada. Si algún día hace falta una, va con su
   .catch() en el mismo renglón.

   ══════════════════════════════════════════════════════════════════
   SIN JAVASCRIPT
   ══════════════════════════════════════════════════════════════════
   La barra la pinta el Liquid entera y visible: no lleva hidden, al revés que
   snippets/ml-buybar.liquid. Sus paradas son enlaces de ancla de verdad y
   funcionan sin este archivo. Este archivo NO intercepta ninguna navegación:
   no hay ni un preventDefault, a propósito, para que pulsar una parada haga
   lo mismo con guion y sin él —incluido cambiar el ancla de la URL, que es lo
   que hace que el botón de volver funcione—.

   LA EXCEPCIÓN ES EL BOTÓN DE COMPRAR, y es la única. Ese sí nace con hidden
   —solo él, no la barra— y lo destapa este archivo cuando encuentra al botón
   del panel al que pasarle el clic. Un botón que solo funciona con el guion
   puesto no puede enseñarse sin él: sin JavaScript el camino entero es el
   panel de compra, que es un formulario de verdad y sigue estando arriba.

   Lo único que apaga es el orden de tabulación mientras la barra no se ve,
   con inert, y lo devuelve al encenderla. Sin IntersectionObserver se retira
   antes de tocar nada y la barra se queda tal cual la dejó el Liquid: con las
   paradas puestas y el botón de comprar todavía tapado. */
(function () {
  "use strict";

  function lista(n) { return Array.prototype.slice.call(n || []); }

  /* En cada uso: puede cambiar en caliente. */
  function suave() {
    var mm = window.matchMedia;
    return mm && mm("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth";
  }

  function correa() {
    var atados = [];
    var atar = function (el, ev, fn, op) {
      el.addEventListener(ev, fn, op);
      atados.push(function () { el.removeEventListener(ev, fn, op); });
    };
    atar.soltar = function () { while (atados.length) atados.pop()(); };
    return atar;
  }

  function altoVentana() {
    return window.innerHeight ||
      (document.documentElement ? document.documentElement.clientHeight : 0) || 0;
  }

  /* ¿Estamos en móvil? Solo lo pregunta la confirmación de añadido, que es la
     que sustituye al cajón lateral donde el cajón no se abre.

     ══════════════════════════════════════════════════════════════════
     SE PREGUNTA POR EL ANCHO **Y POR EL ALTO**, Y LO SEGUNDO ES DEL 03/09/2026
     ══════════════════════════════════════════════════════════════════
     Hasta ese día el corte era solo «(max-width: 768px)», copiado de
     assets/ml-producto.css para que no hubiera dos umbrales que pudieran
     separarse. La conclusión era falsa: LA HOJA Y EL GUION NO PREGUNTAN LO
     MISMO. La hoja pregunta si la disposición es estrecha, que depende del
     ancho; el guion pregunta SI EL CAJÓN CABE, que depende del alto.

     Un iPhone tumbado mide 844×390: pasaba el corte, esMovil() decía que no,
     sincronizarCajon() devolvía el «auto-open» y el cajón se abría sobre 390 px
     de alto. Medido el 03/09/2026 contra «shopify theme dev», con UNA línea:

         844x390   pagar abajo 477   ventana 390  → FUERA
         926x428   pagar abajo 477   ventana 428  → FUERA
        1024x600   pagar abajo 481   ventana 600  → cabe
        1280x800   pagar abajo 681   ventana 800  → cabe

     O sea que «Finalizar compra» acaba a 477-481 px del borde de arriba en
     cualquier ventana baja: por debajo de eso el cajón no tiene salida, que es
     la pantalla que sincronizarCajon() llama «peor que no enseñar nada», y con
     MENOS alto que los 812 sobre los que se tomó aquella decisión.

     EL 500 SALE DE ESA MEDIDA: 481 más un margen para no dejar el botón pegado
     al canto. Y separa lo que hay que separar —un teléfono tumbado llega a 430
     px de alto y una tableta tumbada empieza en 768—; entre medias solo hay
     ventanas de escritorio achatadas, donde tampoco cabría el botón de pagar.

     La coma es una O, y matchMedia la entiende igual que el CSS.

     ESTA EXPLICACIÓN VIVÍA EN assets/ml-producto.js HASTA EL 10/09/2026 y se ha
     mudado aquí sin cambiar una palabra: aquel archivo pesa 32,7 KB contra el
     techo de 32 KB del criterio 14 y este no tiene techo, así que la prosa va
     donde hay sitio y allí queda el puntero. La consulta sigue escrita en los
     dos, que es lo que vigila N35.

     Que la consulta esté escrita en dos archivos es feo y es lo menos malo:
     son dos guiones sueltos sin módulos ni build, y la alternativa
     —preguntárselo al otro por window— ataría esta barra a que la otra esté
     montada, que en esta ficha es justo lo que no pasa. Las dos cadenas tienen
     que decir lo mismo; si se separan, la ficha física y la de formación harán
     cosas distintas con el mismo gesto. */
  var MOVIL = "(max-width: 768px), (max-height: 500px)";
  function esMovil() {
    return !!(window.matchMedia && window.matchMedia(MOVIL).matches);
  }

  /* El cero delante se pone a mano por lo mismo que en el Liquid: no hay
     relleno de cifras ni allí ni aquí, y en esta ficha todos los numerales
     son de dos dígitos. */
  function dos(n) { return n < 10 ? "0" + n : "" + n; }

  /* Una banda de 1 px a la altura «y» de la ventana, escrita como rootMargin.

     La raíz de un IntersectionObserver es la ventana, [0, alto]. El margen la
     empuja: el borde de arriba queda en −margenArriba y el de abajo en
     alto + margenAbajo. Para que la banda sea [y, y+1]:

         margenArriba = −y          margenAbajo = y + 1 − alto

     Los dos valores pueden salir negativos —encogen la raíz— o positivos —la
     agrandan—, y positivos es lo normal aquí: con un bloque de veinte
     pantallas, la línea del 50 % de lo leído cae muy por encima del borde de
     arriba de la ventana. La especificación admite las dos cosas. */
  function banda(y, alto) {
    var r = Math.round(y);
    return (-r) + "px 0px " + (r + 1 - alto) + "px 0px";
  }

  /* Cuánto avanza la línea entre dos repintados, en tanto por uno de lo
     leído. Con 0.01 son cien paradas en todo el recorrido: suficientes para
     que el ojo lo lea como movimiento y no como saltos, y cien avisos en toda
     la lectura contra los miles de un listener de scroll. */
  var PASO = 0.01;

  /* CUÁNTO SE ADELANTA EL ENCENDIDO DE LA BARRA, en tanto por uno del alto de
     la ventana.

     Hasta el 05/09/2026 la barra encendía cuando el bloque de capítulos tocaba
     el borde de arriba —r.top <= 1— y eso llegaba tarde, que es justo lo que
     se notaba al leer la ficha. Medido en el cepillo, con la plantilla de
     físicos:

         móvil 375x812 ..... el botón de comprar se va en y=1109
                             la barra encendía en y=1574   → 465 px sin botón
         escritorio 1440x900  el botón se va en y=677
                             la barra encendía en y=1136   → 459 px sin botón

     Media pantalla larga sin ningún sitio donde comprar, en los dos tamaños.
     Con medio alto de ventana de adelanto la barra entra 406 px antes en móvil
     y 450 en escritorio, o sea 59 y 9 píxeles después de que el botón de
     arriba se vaya: el relevo es casi exacto en los dos, y nunca se ven los
     dos botones a la vez, que era el otro riesgo.

     SOLO ADELANTA EL ENCENDIDO. El apagado sigue siendo «r.bottom > 0», el
     bloque saliendo por arriba, y no se toca: correrlo también dejaría la
     barra apagándose con media pantalla de capítulos todavía en pantalla. Por
     eso hay dos cables y no uno movido, abajo en armarCabecera().

     Y NO SE SUBE DE 0,5, que es lo primero que se le ocurre a cualquiera
     mirando el hueco que quedaba. Está medido y no vale: con 0,80 el hueco de
     375×667 baja a 4 px y en cambio 430×932 enciende la barra con el botón
     del panel todavía a la vista durante 252 px, o sea dos botones de comprar
     en la misma pantalla. La razón está en botonIdo(), que es lo que cierra
     el resto del hueco: esta cifra es una fracción de PANTALLA y lo que hay
     que salvar es una distancia de DOCUMENTO. */
  var ANTICIPO = 0.5;

  /* Y cuánto tiene que haber cambiado lo leído para que valga la pena
     repintar —y, sobre todo, para volver a poner los cables—. Es MEDIO paso,
     y que sean dos cifras y no una es el arreglo del 01/09/2026.

     Con la misma cifra en los dos sitios la línea se congelaba, que es justo
     lo que la cabecera de la sección 3 dice haber diseñado para evitar. Un
     cable puesto en p + PASO avisa cuando el bloque cruza su banda, pero la p
     que se mide en ese frame es casi siempre un pelo MENOR que
     pActual + PASO: la banda se redondea al píxel entero en banda(), y la
     caja se lee donde esté el scroll cuando llega el aviso, no en el píxel
     exacto del cruce. Un pelo menor bastaba, porque la guarda era «< PASO»:
     devolvía SIN rearmar, los cables se quedaban donde ya habían disparado y,
     como un IntersectionObserver solo avisa al CAMBIAR de estado, no volvía a
     despertar nadie hasta la siguiente frontera de capítulo o hasta que
     asomaba el pie. Medido a 1, 2, 5 y 20 px por frame: hasta un 11 % del
     ancho de la barra de desfase. Con medio paso, un 1 %, o sea un paso, que
     es lo diseñado.

     Medio y no menos porque esta cifra sigue siendo la guarda contra el bucle
     de armarCables(): tiene que tragarse el aviso de colocación —que mide
     justo lo que se acaba de medir, así que cae casi en cero— y todo lo que
     el scroll pueda avanzar entre poner un cable y recibir ese primer aviso.
     En un bloque de veinte pantallas, medio paso son ochenta píxeles: más de
     lo que el pulgar más rápido recorre en un frame. */
  var MINIMO = PASO / 2;

  function iniciarBarra(bar) {
    if (bar.mlIniciado) return;
    bar.mlIniciado = true;

    /* La barra y los capítulos son hermanos dentro del envoltorio que Shopify
       pone a la sección («tag»: «section» en el esquema), así que se busca
       primero en el padre y solo después en el documento. Buscar solo en el
       documento funcionaría igual hoy —hay una sección de capítulos por
       ficha— pero ataría el archivo a que siga siendo así. */
    var padre = bar.parentNode;
    var caps = (padre && padre.querySelector) ? padre.querySelector("[data-ml-caps]") : null;
    if (!caps) caps = document.querySelector("[data-ml-caps]");

    /* Sin bloque de capítulos no hay nada que narrar, y sin observador no hay
       manera de seguir la lectura sin escuchar el scroll. En los dos casos la
       barra se queda exactamente como la pintó el Liquid: ni una clase, ni un
       inert, ni un atributo. Una barra estática que funciona es mejor que una
       barra a medio gobernar. */
    if (!caps || !("IntersectionObserver" in window)) return;

    var linea = bar.querySelector("[data-ml-cbar-bar]");
    var listaEl = bar.querySelector("[data-ml-cbar-list]");
    var cuenta = bar.querySelector("[data-ml-cbar-count]");
    var idx = bar.querySelector("[data-ml-cbar-idx]");
    var precio = bar.querySelector("[data-ml-cbar-precio]");
    var cta = bar.querySelector("[data-ml-cbar-cta]");
    var ok = bar.querySelector("[data-ml-cbar-ok]");

    /* Paradas y capítulos, emparejados por el slug. El Liquid imprime el
       mismo valor en los dos sitios —el tipo del bloque— justo para poder
       cruzarlos aquí sin depender del orden ni del número, que dependen de
       qué capítulos estén vivos y eso no se sabe hasta pintar.

       Una parada sin capítulo NO se descarta: se queda con su hueco a null.
       Descartarla dejaría el contador diciendo «03 / 06» en una barra con
       siete paradas, que es mentir sobre lo que se ve. */
    var articulos = lista(caps.querySelectorAll("[data-ml-cap]"));
    var enlaces = lista((listaEl || bar).querySelectorAll("[data-ml-cbar-link]"));
    var capitulos = enlaces.map(function (a) {
      var slug = a.getAttribute("data-ml-cbar-link");
      for (var i = 0; i < articulos.length; i++) {
        if (articulos[i].getAttribute("data-ml-cap") === slug) return articulos[i];
      }
      return null;
    });

    var atar = correa();

    /* ── LO QUE HABÍA ANTES DE TOCAR NADA ────────────────────────────
       destroy() es API pública —la cabecera de este archivo la anuncia— y
       tiene que devolver la barra a como la pintó el Liquid, no dejarla a
       medio gobernar. Importa sobre todo por inert: la hoja declara ese
       atributo como la marca de «aquí manda el guion» y con él la barra es
       fija, transparente, sin puntero y fuera del tabulador
       (assets/ml-capitulos.css, sección 05). Una barra destruida con el inert
       puesto y sin quitar el nodo se queda invisible y sin pulsar para
       siempre. Hoy no muerde porque shopify:section:unload se lleva el nodo
       entero, pero eso es suerte, no diseño: quien llame a destroy() a mano
       se come el fallo.

       Se guarda lo que había en vez de escribir aquí los valores del Liquid:
       el numeral, el total y el ancho de la línea los pinta él, y pueden
       cambiar sin que este archivo se entere.

       DOS COSAS NO SE DEVUELVEN, A PROPÓSITO. El scrollLeft de la lista, que
       es una posición y no un estado pintado: devolverlo sería un salto a la
       vista de quien esté mirando. Y lo que copiar() trae del panel de compra
       —el precio, el rótulo del botón y su estado de agotado—, que son los de
       la variante elegida ahora, mientras que los del Liquid son los de la que
       venía por defecto. Devolver esos sería cambiar un dato cierto por uno
       viejo. Da igual además para el botón, que se vuelve a tapar.

       Y EL «hidden» DEL BOTÓN SÍ SE DEVUELVE, que es la pieza nueva del
       02/09/2026. El Liquid lo pinta tapado y lo destapa este archivo al
       encontrar a quién pasarle el clic; una barra destruida con el botón
       destapado deja un control que ya no tiene quien lo escuche, o sea justo
       el «control muerto» que taparlo existe para evitar. */
    var previo = {
      inert: bar.hasAttribute("inert"),
      encendida: bar.classList.contains("is-on"),
      desborde: listaEl ? listaEl.classList.contains("is-scroll") : false,
      numeral: idx ? idx.textContent : null,
      ancho: linea ? linea.style.width : null,
      ctaTapado: cta ? cta.hidden : false,
      okTapado: ok ? ok.hidden : true,
      total: null,
      paradas: enlaces.map(function (a) {
        return { activa: a.classList.contains("is-active"), actual: a.getAttribute("aria-current") };
      })
    };

    /* ── EL TOTAL DEL CONTADOR ───────────────────────────────────────
       El Liquid imprime «<b>01</b> / 7»: el numeral de la izquierda lo rellena
       a mano y el total no, porque sale de una cuenta y no de una cadena. En
       una barra donde todos los numerales son de dos cifras, ese 7 pelado se
       lee como un fallo. Se rellena aquí, y con el número de paradas que este
       guion gobierna de verdad, que es lo que la barra puede prometer.

       Se toca el nodo de texto y no el innerHTML del párrafo: el <b> de
       [data-ml-cbar-idx] es un hermano y reescribir el párrafo entero lo
       destruiría, dejando sin destino al numeral de cada capítulo. Sin guion
       se lee «01 / 7», que es feo pero cierto. */
    if (cuenta && enlaces.length) {
      var cola = cuenta.lastChild;
      if (cola && cola.nodeType === 3 && /\d/.test(cola.nodeValue)) {
        previo.total = { nodo: cola, texto: cola.nodeValue };
        cola.nodeValue = cola.nodeValue.replace(/\d+/, dos(enlaces.length));
      }
    }

    /* ── 4 · LA LISTA QUE DESBORDA ───────────────────────────────────
       El desplazamiento horizontal se enciende por desborde REAL y no por un
       ancho de pantalla: un @media no puede saber cuánto miden unos rótulos
       que escribe el comerciante y cambian de una ficha a otra.

       Y se mide una sola vez el ancho natural de la lista, no scrollWidth
       contra clientWidth. Esa comparación se muerde la cola: al encender
       is-scroll cambia la medida, la condición deja de cumplirse, se apaga, y
       vuelta a empezar; en la maqueta dejó una franja de veintidós píxeles de
       ancho de ventana con la lista recortada en silencio. Los rótulos no
       parten línea, así que su ancho natural no depende de la ventana: se
       mide con is-scroll quitado y se compara con el ancho que la fila le
       concede. Ninguna de las dos medidas depende de si el desplazamiento
       está encendido, así que no hay realimentación. */
    var anchoRotulos = 0;
    function medirRotulos() {
      if (!listaEl || !listaEl.children.length) return;
      /* «habiaScroll» y no «previo»: «previo» es el objeto de estado de unas
         líneas más arriba —lo que había antes de tocar nada, que devuelve
         destroy()—, y una variable local con ese nombre lo tapaba dentro de
         esta función. Hoy no muerde, porque aquí dentro no se lee el objeto;
         el día que alguien añadiera una línea que sí lo lee, leería un
         booleano y daría «previo.inert is undefined» en cuanto se usara, o un
         TypeError en modo estricto si se le asignara algo. Un nombre que
         miente no cuesta nada arreglarlo hoy y cuesta media hora el día que
         muerda. */
      var habiaScroll = listaEl.classList.contains("is-scroll");
      listaEl.classList.remove("is-scroll");
      anchoRotulos = listaEl.scrollWidth;
      if (habiaScroll) listaEl.classList.add("is-scroll");
    }
    function medirDesborde() {
      if (!listaEl) return;
      if (!anchoRotulos) medirRotulos();
      listaEl.classList.toggle("is-scroll", anchoRotulos > listaEl.getBoundingClientRect().width + 1);
    }

    /* Arrastrar la parada activa a la vista se hace moviendo el scrollLeft de
       la lista y NO con scrollIntoView, aunque la maqueta use scrollIntoView y
       sea más corto: scrollIntoView desplaza todos los contenedores con scroll
       que hay por encima, y el de más arriba es la página. En una barra fija,
       un rótulo que no cabe podría mover el documento entero bajo los pies de
       quien está leyendo. Mover scrollLeft solo puede mover la lista. Es la
       misma forma, y el mismo motivo, que verEnRail() en ml-producto.js. */
    function verEnLista(a) {
      if (!listaEl || !a) return;
      if (listaEl.scrollWidth <= listaEl.clientWidth + 2) return;
      var ca = a.getBoundingClientRect();
      var cl = listaEl.getBoundingClientRect();
      var meta = Math.max(0, listaEl.scrollLeft + ca.left - cl.left - (listaEl.clientWidth - ca.width) / 2);
      if (typeof listaEl.scrollTo === "function") listaEl.scrollTo({ left: meta, behavior: suave() });
      else listaEl.scrollLeft = meta;
    }

    /* ── 1 · CUÁNDO SE VE LA BARRA ───────────────────────────────────
       Encendida mientras queda bloque de capítulos por debajo del borde de
       arriba de la ventana —r.bottom > 0— Y se cumple una de estas dos:

         · el bloque ya está a menos de medio alto de ventana del borde de
           arriba, que es el adelanto de ANTICIPO, o
         · el botón de comprar del panel ya se ha ido por arriba, que es
           botonIdo().

       La primera es la de siempre, corrida. La segunda es el relevo, y está
       porque la primera es una fracción de pantalla y el hueco que hay que
       tapar es una distancia de documento: el porqué medido está donde se
       declara botonIdo(), unas líneas más abajo.

       Apagada, entonces, en dos sitios y solo en dos: por encima del bloque,
       mientras se lee la primera pantalla y con el botón del panel todavía a
       la vista, y por debajo, cuando el bloque entero ha salido por arriba de
       la ventana (r.bottom <= 0). Entre medias no hay ninguna lista de zonas
       que pueda apagarla, porque ya no hay lista.

       Y EL APAGADO NO SE HA MOVIDO. Ni el adelanto ni el relevo pueden
       mantener la barra encendida con el bloque ya fuera: los dos entran
       DENTRO del «r.bottom > 0», no al lado. Lo vigila N23, que exige el
       apagado en el borde de abajo del bloque con dos píxeles de tolerancia.

       EL PIE ERA LA ÚLTIMA ZONA Y SALIÓ EL 02/09/2026, CON EL BOTÓN QUE
       COMPRA. Mientras esta barra solo narraba, apagarla sobre el pie era lo
       correcto: no había nada que narrar ahí. Ahora lleva un
       [data-ml-cbar-cta] que le pasa el clic al [data-ml-add] del panel, y
       con eso vuelve a aplicar palabra por palabra la decisión que la casa ya
       tomó el 21/08/2026 para assets/ml-producto.js, donde el pie salió de
       las zonas por este mismo motivo: una barra que compra y se apaga en el
       pie no consigue nada más que dejar sin comprar a quien ha llegado al
       final. Medido en la ficha física, el pie son 324 px de 7386: apagar ahí
       costaba el último 4 % del recorrido, que es justo el tramo en el que
       alguien acaba de leerse los siete capítulos enteros.

       LA OTRA ZONA —EL BLOQUE DE CIERRE— SE HABÍA IDO ANTES, CON EL ENLACE.
       Hasta ese mismo día el botón era un <a href="#ancla"> y de ese href se
       sacaba su identificador. El botón ya no navega y no tiene href del que
       sacar nada, y no se sustituye por un getElementById("ml-comprar") como
       el de assets/ml-producto.js: ese identificador lo pinta
       sections/ml-producto-banda.liquid (retirado con ml-05 el 05/09/2026; está en git), que templates/product.ml-fisicos.json
       —la única plantilla que monta esta sección— no monta, así que sería una
       rama que no puede ejecutarse nunca y que ninguna prueba puede morder.

       QUÉ SIGNIFICA ESTO EN LA FICHA QUE SE SUBE, MEDIDO. La plantilla monta
       el hero y los capítulos, y detrás solo va el pie. Para que el bloque
       salga entero por arriba de la ventana hace falta una pantalla completa
       de documento detrás de él, y un pie de 324 px no la da: la condición de
       apagado queda por debajo del fondo del documento y no se alcanza nunca
       bajando. Medido el 02/09/2026 en /banco/capitulos, con 720 px de
       ventana: enciende en y=875, el pie asoma en y=7613, el documento se
       acaba en y=7937 y el punto de apagado cae en y=8333, 396 px más allá.
       O sea que en esta ficha la barra se queda encendida hasta el final del
       documento y solo se apaga volviendo a subir por encima de los
       capítulos, que es exactamente lo que se quiere: se puede comprar
       también sobre el pie.
       La condición de abajo no es por eso decoración: es la red para el día
       que la ficha lleve algo detrás de los capítulos —otra sección, un pie
       más alto—, que sin ella se quedaría con una barra de capítulos encima
       para siempre. Y como la ficha de hoy no llega a ejercitarla, la prueba
       N23 se añade una pantalla de documento vacío al final del <body> y
       recorre ese borde de píxel en píxel: exige que el apagado caiga en el
       borde de abajo del bloque y no donde asoma el pie, que en /banco/capitulos
       son 720 px antes.

       Y si las dos barras conviven en la misma ficha, la que se apaga es esta:
       lo hace la bandera de más abajo. */

    /* ── Y SI LA OTRA BARRA ESTÁ MONTADA, ESTA NO SE ENCIENDE ────────
       LA REGLA NO HA CAMBIADO Y EL MOTIVO SÍ. Cuando se escribió, el motivo
       era que esta barra narra y aquella compra, así que en una ficha con las
       dos la que sobra es la que no lleva al carrito. Desde el 02/09/2026 esta
       también compra, y entonces el motivo es el contrario y más fuerte: son
       DOS BOTONES QUE HACEN EXACTAMENTE LO MISMO —los dos le pasan el clic al
       mismo botón del panel— en dos barras fijas al mismo borde de la pantalla.
       Enseñar el mismo botón dos veces sobra, y en un teléfono además estorba.

       Lo único que evitaba las dos barras a la vez en la ficha física era el
       «mostrar_barra: false» escrito a mano en
       templates/product.ml-fisicos.json, y ese ajuste nace en true en el
       esquema del hero. O sea que bastaba con marcar la casilla en el editor
       de temas para tener .ml-buybar —fija, abajo, z-index 60— encima de
       .ml-cbar —fija, abajo, z-index 39—. En un teléfono, una sobre otra y a
       un dedo de distancia.

       Y SE APAGA ESTA Y NO AQUELLA, que también hay que decirlo. Aquella es
       una pastilla flotante que solo enseña título, precio y botón; esta es
       además la navegación por los capítulos, así que apagar esta pierde la
       navegación y apagar aquella no perdería nada. Se prefiere igualmente
       apagar esta porque quien marca la casilla del hero está pidiendo la
       barra de compra, y porque el guardián tiene que vivir en un solo sitio:
       el que puede preguntar por el otro sin depender de que el otro exista.

       LA PREGUNTA SE HACE UNA VEZ Y SE GUARDA. pintar() corre en cada aviso de
       cada observador, que en una lectura entera son cien largos, y un
       querySelector ahí dentro sería recorrer el documento cada vez para
       preguntar algo que no cambia mientras nadie edite la página. Así que se
       pregunta al arrancar, se guarda, y pintar() solo lee la bandera.

       Y SE APAGA COMO SE APAGA SIEMPRE, no con un camino aparte: la bandera
       entra en la misma cuenta que la geometría, así que la barra queda sin is-on
       y con inert puesto, que es el estado que la hoja dibuja como apagada
       (assets/ml-capitulos.css, sección 05) y el que deja las paradas fuera del
       tabulador. Un segundo camino para apagarla sería un segundo sitio donde
       se puede quedar a medias.

       QUÉ PASA EN EL EDITOR DE TEMAS, QUE ES DONDE SÍ CAMBIA. Marcar o
       desmarcar la casilla vuelve a pintar la sección del hero, y eso dispara
       shopify:section:load con el marcado nuevo ya en el documento: ahí se
       vuelve a preguntar —mlRevisar(), que llama el oyente del final del
       archivo— y la bandera cambia en los dos sentidos, así que la barra se
       apaga al marcar y vuelve al desmarcar sin recargar nada.

       LO QUE NO SE CUBRE, Y SE SABE: borrar la sección del hero entera. Eso
       solo dispara shopify:section:unload, y cuando llega ese aviso no hay
       ninguna garantía de que el nodo viejo ya no esté en el documento, así que
       la pregunta podría contestar «sí la hay» sobre una barra que se está
       yendo. Se prefiere no preguntar a contestar mal: la barra de capítulos se
       queda apagada hasta que se recargue la vista previa. Pasa en el editor y
       no en la tienda, donde ninguna sección aparece ni desaparece sola, así
       que no lo ve ningún cliente. */
    var otraBarra = false;
    function mirarOtraBarra() {
      otraBarra = !!document.querySelector("[data-ml-buybar]");
    }
    mirarOtraBarra();

    bar.mlRevisar = function () {
      var habia = otraBarra;
      mirarOtraBarra();
      /* Y el panel, por lo mismo que la otra barra: quien se sustituye en el
         editor es OTRA sección, y su aviso no pasa por esta barra. Rearmar
         solo cuando de verdad ha cambiado el nodo: mlRevisar() se llama en
         CADA shopify:section:load, también en los de secciones que no tienen
         nada que ver, y tirar el espía y los tres cables en todos ellos sería
         trabajo por nada. armarCabecera() es quien vuelve a poner cableBoton
         sobre el botón nuevo. */
      var cambioPanel = mirarPanel();
      if (cambioPanel) {
        armarEspia();
        armarCabecera();
        pintarBotonVenta();
        copiar();
      }
      if (otraBarra !== habia) repintar();
      else if (cambioPanel) repintar();
    };

    /* ¿El foco está dentro de la barra ahora mismo? Se pregunta con contains
       y no guardando quién tiene el foco, porque el foco lo mueve el navegador
       y cualquier copia se queda vieja. */
    function conFoco() {
      var a = document.activeElement;
      return !!(a && a !== document.body && bar.contains(a));
    }

    /* ── ¿EL BOTÓN DE ARRIBA YA SE HA IDO? ──────────────────────────
       El segundo motivo de encendido, y existe porque el primero no puede
       cerrar el hueco él solo: ANTICIPO es una FRACCIÓN DE PANTALLA y lo que
       hay que salvar es una DISTANCIA DE DOCUMENTO. Medido en la ficha del
       cepillo, con el hueco sin ningún botón de comprar a la vista:

           ventana     hay que salvar     medio alto de ventana
           375×667          535 px               334 px
           390×844          512 px               422 px
           430×932          496 px               466 px

       La distancia que hay que salvar la fija el documento —dónde acaba el
       panel de compra y dónde empieza el bloque de capítulos— y no cambia
       con el alto de la ventana; la fracción sí, y encima al revés: da MENOS
       adelanto justo en la pantalla pequeña, que es donde más falta hace. Por
       eso con una sola cifra no se cierra. Medido: con 0,80 el hueco de
       375×667 baja a 4 px, pero en 430×932 la barra enciende en y=834 con el
       botón del panel todavía a la vista hasta y=1082, o sea 252 px con DOS
       botones de comprar en la misma pantalla. Eso no es una mejora, es otro
       fallo. Así que ANTICIPO se queda en 0,5 y el resto lo cierra esto.

       Y en cuanto el botón del panel cruza el borde de arriba ya no hay nada
       que solapar: enseñar la barra a partir de ahí no puede duplicar ningún
       botón, porque el otro ya no está.

       SE PREGUNTA «rb.bottom <= 0» Y NO «no se ve», y la diferencia es todo.
       Con la página arriba del todo el botón del panel está POR DEBAJO del
       pliegue —medido: top 1074 con una ventana de 844— así que tampoco «se
       ve», y un «no se ve» a secas encendería la barra desde la primera
       pantalla, que es exactamente lo contrario de lo que hace falta. Lo que
       se pregunta es si se ha ido POR ARRIBA, que es cuando deja de haber
       relevo.

       Sin panel —o con un panel sin [data-ml-add]— devuelve «no»: ahí la
       barra ni siquiera destapa su botón, así que adelantar el encendido no
       adelantaría ningún sitio donde comprar.

       fuenteBoton se declara más abajo, con el resto de la sección 5. No es
       un olvido y no muerde: la primera llamada a pintar() es la de
       repintar() del arranque, que va después de esa declaración, y los
       avisos de los observadores llegan en tareas posteriores.

       Y SE EXIGE ALTO ANTES DE CREER EL rb.bottom, que es la guarda que
       faltaba hasta el 06/09/2026. Un nodo DESCONECTADO del documento
       devuelve getBoundingClientRect() todo a ceros, y «0 <= 0» es cierto: la
       barra se encendía desde el primer píxel, que es justo lo contrario de
       lo que este cable viene a hacer. Con la guarda, un botón que ya no está
       en el documento contesta «no se ha ido» —no hay relevo que dar— y manda
       el adelanto de ANTICIPO, que es el estado de una ficha sin panel.

       Pasa en el editor de temas, y pasaba a pesar de que mlRevisar() vuelva
       a resolver el panel: entre la sustitución de la sección y el aviso cabe
       una medida. Medido el 06/09/2026 en /products/the-secret-brush a
       390x844: cargar la ficha, sustituir la sección del hero por un clon,
       disparar shopify:section:load sobre ella y provocar un resize daba
       {on:true, inert:false, barTop:734} con el documento en y=0, cuando lo
       que tocaba es {on:false, inert:true, barTop:844}. */
    function botonIdo() {
      if (!fuenteBoton) return false;
      var rb = fuenteBoton.getBoundingClientRect();
      if (!(rb.height > 0)) return false;
      return rb.bottom <= Math.round(techo());
    }

    /* ── EL TECHO, Y POR QUÉ NO ES CERO ─────────────────────────────
       Del 10/09/2026, y es la mitad que faltaba del relevo. Hasta ese día
       botonIdo() preguntaba «rb.bottom <= 0», o sea el borde de arriba de la
       VENTANA, y por encima de ese borde no hay nada: hay una cabecera
       pegajosa de sesenta píxeles. El botón se mete debajo de ella y deja de
       contestar al dedo mucho antes de cruzar el cero, así que entre lo uno y
       lo otro quedaba un tramo sin ningún sitio donde comprar.

       Medido el 10/09/2026 contra `shopify theme dev` a 390x844, píxel a
       píxel y preguntando con elementFromPoint, en las TRES familias de
       ficha. Sale casi idéntico en las tres porque no depende del contenido
       sino de la cabecera:

         ficha        el centro del botón deja   la barra contesta   hueco
                      de contestar en            desde
         formación    y=1163                     y=1260               96
         físicos      y=1046                     y=1147              101
         servicios    y=1237                     y=1335              97

       Es la queja del cliente escrita con sus palabras: la barra con el
       botón de compra aparece demasiado tarde. Y NO SE ARREGLA SUBIENDO
       ANTICIPO, que es lo primero que se piensa: eso está medido y
       descartado unas líneas más arriba, porque una fracción de pantalla no
       puede salvar una distancia de documento.

       DE DÓNDE SALE EL NÚMERO. Del token `--ml-techo` de
       assets/ml-base.css, que vale el alto de la cabecera cuando Horizon la
       deja pegada y cero cuando no. La cuenta, los dos selectores y por qué
       el cero se declara están allí, con las medidas. Aquí solo se lee.

       SE LEE EN CADA PINTADA Y NO SE GUARDA. La cabecera cambia de alto al
       girar el teléfono, al abrir un submenú y al cambiar el logotipo desde
       el editor de temas, y `assets/utilities.js` reescribe el número cada
       vez. Una copia guardada al arrancar se quedaría vieja justo en los
       tres casos en que importa. Cuesta un getComputedStyle por aviso de
       observador, no por píxel de scroll: este guion no escucha «scroll» ni
       una vez.

       Y SE LEE DE `bar` Y NO DEL `body`: el token es heredado, así que
       cualquier nodo de dentro contesta lo mismo, y preguntárselo al
       elemento que ya se tiene en la mano ahorra un querySelector. La misma
       función, palabra por palabra, está en assets/ml-producto.js: las dos
       barras tienen el mismo techo y ninguna puede depender de que la otra
       esté montada, que es el argumento de MOVIL. */
    function techo() {
      var v = parseFloat(getComputedStyle(bar).getPropertyValue("--ml-techo"));
      return v > 0 ? v : 0;
    }

    function pintar() {
      var r = caps.getBoundingClientRect();
      /* El adelanto se mide contra la ventana, así que se pregunta cada vez:
         girar el teléfono cambia el alto y con él la línea de encendido. Si
         altoVentana() devolviera 0 —no debería, pero es barato cubrirlo— el
         producto es 0 y queda la condición de siempre, «tocar el borde».

         Y SE COMPARA CONTRA EL MISMO VALOR REDONDEADO QUE USA banda(), CON
         SU «+1». No es un margen inventado: es la coherencia que el código
         original ya tenía y que se rompió al meter la fracción. Con banda(0,
         vh) la banda es [0, 1] y la condición era «r.top <= 1»; al pasar a
         banda(vh * ANTICIPO, vh) la banda es [L, L+1] con L redondeado, pero
         la condición se quedó comparando contra el valor SIN redondear.

         Lo que eso cuesta, medido: un IntersectionObserver avisa cuando el
         bloque entra en la banda, o sea cuando r.top < L+1, y en ese
         fotograma r.top cae casi siempre entre vh * ANTICIPO y L+1. Ahí la
         condición salía falsa, y como un observador solo avisa AL CAMBIAR de
         estado, ese cable no volvía a avisar NUNCA: el encendido se quedaba
         esperando al siguiente cable de avance, que está a un PASO —56,9 px
         en esta ficha—. Medido en la ficha del cepillo a 390×844, bajando a
         zancadas de pulgar: el umbral cae en y=1151 y la barra encendía en
         y=1183 con 8 px por cuadro, y en y=1191 con 20 y con 40. A 60 px por
         cuadro se notaba en los cuatro tamaños. Con el redondeo puesto, la
         condición es cierta en el mismo fotograma en que el cable avisa. */
      /* ── DOS MOTIVOS DE ENCENDIDO, Y EL SEGUNDO TAMBIÉN VALE ABAJO ──
         Del 10/09/2026. Hasta ese día esto era una escalera: primero se
         exigía que el bloque estuviera EN SU BANDA —«r.bottom > 0», o sea
         que quedara bloque por debajo del borde de arriba— y solo dentro de
         esa exigencia se consultaba botonIdo(). Con lo cual, en cuanto el
         bloque salía por arriba, la barra se apagaba pasara lo que pasara.

         Y DEBAJO DEL BLOQUE NO HAY OTRO SITIO DONDE COMPRAR. En la ficha del
         cepillo, que es la única que monta capítulos, debajo hay el pie y
         nada más. Medido el 10/09/2026 contra `shopify theme dev` a 390x844:
         documento de 8556 px, bloque de capítulos acabado en y=7268 y pie de
         1289 px. La barra se retiraba en y=7268 y el recorrido llega a 7712,
         o sea 445 PÍXELES —0,53 pantallas, el 5,8 % del recorrido— con la
         barra a opacidad cero, con `inert` y sin nada que la relevara. Las
         otras dos fichas sí llegan al fondo con su barra puesta, y esa
         asimetría es la que delataba el fallo: no es una decisión, es un
         descuido de forma.

         Y NO ES NUEVO, es la misma decisión que assets/ml-producto.js tomó el
         21/08/2026 al sacar el pie de sus zonas: «el pie no lleva ningún
         botón de comprar, así que lo único que conseguía era quitar la única
         forma de comprar justo cuando alguien acaba de leerse la ficha
         entera». Aquí se llegaba al mismo sitio por otro camino.

         POR QUÉ ANTES NO SE VEÍA. Cuando N23 midió esto, el 02/09/2026, el
         pie era más corto que una pantalla y el punto de apagado caía POR
         DEBAJO del fondo del documento —apagado en y=8333, documento agotado
         en y=7937—, así que la barra llegaba al final por geometría y no por
         decisión. El pie ha crecido y el fallo ha salido solo. Es la razón
         de que N23 tenga que fabricarse una pantalla de documento.

         LO QUE NO CAMBIA: por encima del bloque sigue mandando lo mismo. Con
         el documento arriba del todo, botonIdo() contesta «no» —el botón del
         panel está por debajo del pliegue, no se ha ido por arriba— así que
         la barra sigue naciendo apagada. Y sin panel de compra, botonIdo()
         también contesta «no», así que en una página sin botón que relevar la
         barra sigue apagándose al pasar los capítulos, como siempre. */
      var on = !otraBarra && r.height > 0;
      if (on) {
        var enBanda = r.bottom > 0;
        if (enBanda) {
          if (r.top > Math.round(altoVentana() * ANTICIPO) + 1) enBanda = false;
        }
        if (!enBanda) on = botonIdo();
      }
      /* ── LA BARRA NO SE APAGA DEBAJO DEL FOCO ────────────────────────
         Si alguien ha llegado tabulando hasta una parada y en ese momento se
         cumple la condición de apagado, apagarla lo deja tirado: con inert
         puesto, el navegador se lleva el foco al <body> y el siguiente
         tabulador vuelve a empezar por la cabecera de la página. No hay
         ningún aviso; simplemente se pierde el sitio.

         Así que mientras el foco esté dentro, la barra se queda encendida y
         visible. No es una excepción de diseño: es lo que la barra ya promete
         con inert —«si se puede enfocar, se ve»— dicho en el otro sentido.
         Quien tabula fuera dispara el «focusin» de más abajo y la barra se
         apaga entonces, que es cuando ya no se lleva a nadie por delante.

         La geometría manda igual para todos los demás casos: esto solo puede
         RETRASAR el apagado, nunca encender una barra que no tocaba. */
      if (!on) {
        if (conFoco()) on = true;
      }
      bar.classList.toggle("is-on", on);
      /* inert y no un tabIndex por enlace: la barra apagada está a opacidad
         cero pero sigue en el documento, y ni transform ni opacity impiden el
         foco. Sin esto deja ocho paradas de tabulación invisibles detrás del
         botón de comprar. Lo quita el propio guion al encenderla, así que no
         esconde nada que no pueda volver a enseñar. */
      if (on) bar.removeAttribute("inert");
      else bar.setAttribute("inert", "");
    }

    /* ── 2 · QUÉ CAPÍTULO SE ESTÁ LEYENDO ────────────────────────────
       El activo es el que cruza una línea imaginaria a poco menos de la mitad
       de la ventana. Los capítulos van pegados, así que por esa línea pasa
       exactamente uno en cada momento y no hay empates que resolver. Es la
       misma línea que usa la banda del observador de más abajo: una sola
       cifra para las dos, o el observador despertaría en un sitio y la cuenta
       se haría en otro. */
    var LINEA = 0.475;
    var iActual = -1;

    function cual() {
      var y = altoVentana() * LINEA;
      for (var i = 0; i < capitulos.length; i++) {
        var c = capitulos[i];
        if (!c) continue;
        var r = c.getBoundingClientRect();
        if (r.height > 0 && r.top <= y && r.bottom > y) return i;
      }
      return -1;
    }

    function pintarActivo() {
      var i = cual();
      /* Fuera de los capítulos no se borra el último: arriba manda el 01 que
         ya trae el Liquid y abajo la barra se está retirando. Dejar la lista
         sin ninguna parada marcada en ese tramo sería un parpadeo sin ninguna
         información detrás. */
      if (i < 0 || i === iActual) return;
      iActual = i;
      for (var n = 0; n < enlaces.length; n++) {
        var esta = n === i;
        enlaces[n].classList.toggle("is-active", esta);
        if (esta) enlaces[n].setAttribute("aria-current", "true");
        else enlaces[n].removeAttribute("aria-current");
      }
      if (idx) idx.textContent = dos(i + 1);
      verEnLista(enlaces[i]);
    }

    /* ── 3 · LA LÍNEA DE AVANCE ──────────────────────────────────────
       Lo leído es la parte del bloque de capítulos que ya ha pasado por
       encima del borde de abajo de la ventana:

           avance = (alto de la ventana − top del bloque) / alto del bloque

       Vale 0 cuando el bloque asoma por debajo y 1 cuando su última línea
       llega al borde de abajo, que es justo cuando ya se ha enseñado todo. No
       hace falta saber por dónde va el scroll: la caja del bloque lo lleva
       dentro.

       ══════════════════════════════════════════════════════════════
       EL PROBLEMA DE VERDAD: DESPERTAR SIN ESCUCHAR EL SCROLL
       ══════════════════════════════════════════════════════════════
       Un observador solo avisa cuando su objetivo cruza un umbral. Con
       umbrales finos sobre cada capítulo se despierta bien mientras entra y
       mientras sale, pero un capítulo más alto que la ventana —y aquí todos
       lo son: abren con una fotografía a pantalla completa— pasa un buen rato
       tapándola entera, y ahí su proporción visible no cambia: ni un aviso.
       En un capítulo de dos pantallas eso es una pantalla entera de scroll con
       la línea congelada y después un salto. Se ve, y se ve mal.

       La solución es un cable trampa que se vuelve a poner solo. En vez de
       preguntar «¿cuánto se ve del capítulo?», se pone una banda de 1 px
       cruzando la ventana justo a la altura a la que estará el borde de
       arriba del bloque cuando lo leído haya avanzado un paso más, y se
       observa el bloque contra esa banda. El aviso llega en ese píxel exacto,
       se repinta, y los cables se ponen un paso más allá. Dos cables, uno por
       cada sentido de la lectura. La banda cae casi siempre fuera de la
       ventana —a veinte pantallas por encima si hace falta—, y eso es legal:
       ver banda(), arriba.

       Cuesta cien avisos en toda la lectura, y el paso es el mismo tanto si el
       capítulo mide una pantalla como si mide cuatro.

       LA GUARDA CONTRA EL BUCLE. Poner un observador dispara un aviso
       inmediato con el estado de ese momento. Como ese aviso vuelve a entrar
       por avanzar(), si volviera a poner los cables no pararía nunca. Lo corta
       la primera línea del if: si lo leído no ha cambiado más de MEDIO paso
       desde lo ya pintado, ni se pinta ni se rearma. El aviso de colocación
       siempre cae ahí, porque mide justo lo que se acaba de medir.

       MEDIO paso, MINIMO, y no PASO: con la misma cifra que la separación de
       los cables, la guarda se tragaba el aviso del propio cable y dejaba la
       línea congelada. El porqué, medido, está donde se declara MINIMO. */
    var cableAbajo = null;
    var cableArriba = null;
    var pActual = -1;

    function soltarCables() {
      if (cableAbajo) { cableAbajo.disconnect(); cableAbajo = null; }
      if (cableArriba) { cableArriba.disconnect(); cableArriba = null; }
    }

    function armarCables(p, alto, vh) {
      soltarCables();
      cableAbajo = new IntersectionObserver(repintar, {
        rootMargin: banda(vh - (p + PASO) * alto, vh), threshold: 0
      });
      cableAbajo.observe(caps);
      cableArriba = new IntersectionObserver(repintar, {
        rootMargin: banda(vh - (p - PASO) * alto, vh), threshold: 0
      });
      cableArriba.observe(caps);
    }

    function avanzar() {
      var r = caps.getBoundingClientRect();
      var alto = r.height;
      var vh = altoVentana();
      /* Sin caja medible no se inventa un avance: se deja la línea donde
         está. Pasa en el arranque, con las fotografías todavía sin sitio
         reservado, y pasa en el banco de Liquid, que no maqueta. */
      if (!(alto > 0) || !(vh > 0)) return;
      var p = (vh - r.top) / alto;
      p = p < 0 ? 0 : p > 1 ? 1 : p;
      if (pActual >= 0 && Math.abs(p - pActual) < MINIMO) return;
      pActual = p;
      if (linea) linea.style.width = (p * 100).toFixed(1) + "%";
      armarCables(p, alto, vh);
    }

    /* Todo aviso hace lo mismo: volver a mirar las tres cosas. Son tres
       lecturas de geometría y tres escrituras cortas, y tenerlas juntas evita
       la clase de fallo en que la barra se enciende con el capítulo de antes
       marcado porque cada observador repintaba solo su parte. */
    function repintar() {
      pintar();
      pintarActivo();
      avanzar();
    }

    /* El cable fijo del borde de arriba. La condición de encendido es «el
       bloque toca el borde de arriba de la ventana y todavía queda bloque por
       debajo», y eso es exactamente lo que responde una banda de 1 px puesta
       en y = 0. Sin él, el encendido tendría que esperar al siguiente cable de
       avance y la barra podría aparecer hasta un paso tarde; con nueve
       capítulos, un paso son ochenta píxeles.

       Y DESDE EL 02/09/2026 ES TAMBIÉN EL CABLE DEL APAGADO, que es la mitad
       que antes ponía el observador de las zonas. Una banda en y = 0 cambia
       de estado en los DOS bordes del bloque: cuando su borde de arriba cruza
       la línea —el encendido— y cuando la cruza el de abajo, que es
       exactamente el «r.bottom <= 0» que apaga. Los cables de avance no
       sirven para eso: lo leído se recorta a 1 en avanzar(), así que en cuanto
       el bloque llega al borde de abajo de la ventana dejan de rearmarse y
       nadie vuelve a despertar. Sin este cable, la barra se quedaría encendida
       al pasar los capítulos hasta el siguiente redimensionado. */
    var cableCabecera = null;
    var cableAnticipo = null;
    var cableBoton = null;
    function armarCabecera() {
      if (cableCabecera) { cableCabecera.disconnect(); cableCabecera = null; }
      if (cableAnticipo) { cableAnticipo.disconnect(); cableAnticipo = null; }
      if (cableBoton) { cableBoton.disconnect(); cableBoton = null; }
      var vh = altoVentana();
      if (!(vh > 0)) return;
      cableCabecera = new IntersectionObserver(repintar, { rootMargin: banda(0, vh), threshold: 0 });
      cableCabecera.observe(caps);
      /* EL SEGUNDO CABLE, EL DEL ADELANTO. El de arriba sigue en y=0 porque es
         el que despierta el APAGADO —el borde de abajo del bloque cruzando la
         línea— y ese no se ha movido. Este otro despierta el ENCENDIDO en la
         línea nueva, ANTICIPO por el alto. Con un solo cable corrido habría que
         elegir: o el encendido llega tarde, o el apagado llega pronto. */
      if (ANTICIPO > 0) {
        cableAnticipo = new IntersectionObserver(repintar, {
          rootMargin: banda(vh * ANTICIPO, vh), threshold: 0
        });
        cableAnticipo.observe(caps);
      }
      /* EL TERCER CABLE, EL DEL RELEVO. El segundo motivo de encendido lo
         decide botonIdo(), y sin despertador sería una condición que nadie
         comprueba en el momento en que se cumple: los otros dos cables miran
         el bloque de capítulos y no se enteran de por dónde va el botón del
         panel. Una banda de 1 px sobre el propio botón cambia de estado
         exactamente cuando su borde de abajo cruza esa línea, que es la
         pregunta de botonIdo(). Igual que los otros dos: el observador avisa,
         la geometría decide.

         Y LA BANDA VA EN EL TECHO, NO EN CERO, desde el 10/09/2026. Es la
         misma coherencia que este archivo ya había pagado una vez con
         ANTICIPO: si la condición pregunta por una línea y el despertador
         vigila otra, hay un tramo en el que la condición ya ha cambiado y
         nadie va a mirarla —y un observador solo avisa AL CAMBIAR, así que no
         vuelve a avisar—. Medido el 10/09/2026 en /banco/capitulos?techo=1 a
         390×845, con la condición movida al techo y el cable todavía en cero:
         bajando salía bien de milagro, y SUBIENDO la barra se quedaba
         encendida 102 px con el botón del panel otra vez a la vista, de y=1084
         a y=983. O sea dos sitios donde comprar a la vez, que es justo lo que
         N39 y N54 no dejan pasar.

         banda() redondea al píxel, así que botonIdo() compara contra el mismo
         valor redondeado. Los dos números tienen que salir de la misma cuenta
         o vuelve el mismo fallo con otra cara. */
      if (fuenteBoton) {
        cableBoton = new IntersectionObserver(repintar, {
          rootMargin: banda(techo(), vh), threshold: 0
        });
        cableBoton.observe(fuenteBoton);
      }
    }

    /* La banda del capítulo activo. Solo despierta: quien decide sigue
       siendo la geometría de cual() y de pintar(). */
    var obsBanda = new IntersectionObserver(repintar, {
      rootMargin: "-" + (LINEA * 100).toFixed(1) + "% 0px -" +
        (100 - LINEA * 100 - 5).toFixed(1) + "% 0px",
      threshold: 0
    });
    capitulos.forEach(function (c) { if (c) obsBanda.observe(c); });

    /* ── 5 · EL PRECIO Y EL RÓTULO DEL BOTÓN ─────────────────────────
       La barra no sabe de variantes y no tiene que aprender. Quien las
       gobierna es ml-producto.js sobre el panel [data-ml-buy]: lee el JSON de
       [data-ml-variants], escribe el precio en [data-ml-price-now] y cambia la
       leyenda del botón entre el rótulo de venta y el de agotado. Aquí solo se
       copia lo que el panel ya dice, así que sigue habiendo un solo sitio en
       todo el tema donde se decide qué precio se enseña.

       POR QUÉ SE MIRA Y NO SE ESCUCHA. ml-producto.js empuja el precio a la
       barra de compra con un document.querySelector y podría empujarlo también
       aquí; no lo hace porque aquella barra es de su propia sección y esta es
       de otra que puede no estar montada. Y escuchar «change» en
       [data-ml-opts] desde este lado dejaría a los dos guiones colgados del
       mismo evento, con el orden decidido por cuál se cargó antes: la mitad de
       las veces copiaríamos el precio anterior. Mirando el nodo del panel con
       un MutationObserver da igual quién escriba y cuándo. No hay bucle: esto
       lee del panel y escribe en la barra, que el observador no mira.

       EL RÓTULO SE MEZCLA A PROPÓSITO. Mientras hay existencias manda el de la
       barra, que pone su propio Liquid; cuando no las hay se copia el del
       panel, que ya viene traducido y distingue «agotado» de «no disponible».
       Un botón que sigue ofreciendo comprar una variante agotada es una
       promesa falsa.

       Y DESDE EL 02/09/2026 TAMBIÉN SE COPIA EL «disabled», que antes no. La
       razón de no copiarlo está escrita y era buena mientras duró: «no es un
       botón que compra, es un enlace al panel, y en el panel es donde se elige
       otra variante, así que sigue haciendo algo útil». Ahora sí compra, y un
       botón de comprar habilitado sobre una variante agotada no hace nada
       útil: se pulsa, no pasa nada y el cliente cree que ha fallado él. Se le
       pone el atributo y la clase is-off, que es lo que assets/ml-base.css ya
       dibuja como apagado, y es lo mismo que ml-producto.js le hace al botón
       de la otra barra en pintarBoton().

       EL RÓTULO DE VENTA SE ESCRIBE AUNQUE ESTÉ VACÍO, y no es un descuido.
       Con el metacampo sin rellenar, rotuloVenta es la cadena vacía y el botón
       se pinta mudo a propósito. Si al volver de una variante agotada solo se
       escribiera «cuando hay algo que escribir», el botón se quedaría diciendo
       «Agotado» encima de una variante disponible: una barra mintiendo sobre
       el mismo dato que el panel enseña bien, tres líneas más arriba. */
    var panel = null;
    var fuentePrecio = null;
    var fuenteBoton = null;
    var fuenteTexto = null;
    var rotuloVenta = cta ? (cta.textContent || "").trim() : "";
    var espia = null;

    /* ── EL PANEL SE VUELVE A BUSCAR, NO SE CONGELA ───────────────────
       Hasta el 06/09/2026 estas cuatro referencias se resolvían una vez, al
       arrancar, y no se volvían a mirar. En la tienda eso está bien —ninguna
       sección aparece ni desaparece sola— pero EN EL EDITOR DE TEMAS la
       sección del hero se sustituye entera cada vez que se toca uno de sus
       ajustes, y el nodo viejo se queda desconectado con todo lo que apuntara
       a él. mlRevisar(), que es lo único que se vuelve a preguntar en
       shopify:section:load, solo releía otraBarra.

       Y NO ERA UN DETALLE DE GEOMETRÍA. Medido el 06/09/2026 en
       /products/the-secret-brush, sustituyendo la sección del hero por un
       clon: el botón de comprar de esta barra dejaba de comprar. Le pasa el
       clic a fuenteBoton.click(), y fuenteBoton era el botón muerto: el vivo
       no recibía nada. Además cableBoton se quedaba observando ese mismo nodo
       —o sea, sin despertar nunca— y copiar() leía el precio de una copia
       congelada.

       Se resuelven los cuatro juntos porque salen del mismo panel, y se
       devuelve si ha cambiado para que quien llama sepa si hay que rearmar el
       espía, los cables y el rótulo. Devolver «ha cambiado» y no rearmar aquí
       dentro es a propósito: en el arranque todavía no existe nada de eso. */
    function mirarPanel() {
      var panelAntes = panel;
      var botonAntes = fuenteBoton;
      panel = document.querySelector("[data-ml-buy]");
      fuentePrecio = panel
        ? (panel.querySelector("[data-ml-price-now]") || panel.querySelector("[data-ml-price]"))
        : null;
      fuenteBoton = panel ? panel.querySelector("[data-ml-add]") : null;
      fuenteTexto = fuenteBoton
        ? (fuenteBoton.querySelector("[data-ml-cta-text]") || fuenteBoton)
        : null;
      if (panel !== panelAntes) return true;
      return fuenteBoton !== botonAntes;
    }
    mirarPanel();

    /* Siempre textContent: lo que se copia sale del panel, que lleva dentro
       texto del comerciante. Aquí no se inyecta marcado. */
    function copiar() {
      if (precio && fuentePrecio) {
        var t = (fuentePrecio.textContent || "").trim();
        if (t && precio.textContent !== t) precio.textContent = t;
      }
      if (cta && fuenteBoton) {
        var agotado = !!fuenteBoton.disabled;
        var quiere = rotuloVenta;
        if (agotado && fuenteTexto) {
          quiere = (fuenteTexto.textContent || "").trim() || rotuloVenta;
        }
        if (cta.textContent !== quiere) cta.textContent = quiere;
        if (cta.disabled !== agotado) cta.disabled = agotado;
        cta.classList.toggle("is-off", agotado);
      }
    }

    /* Se arma en una función porque el panel puede cambiar bajo los pies —ver
       mirarPanel()— y un MutationObserver no deja cambiar de objetivo: hay
       que soltarlo y hacer otro. Espiar al panel muerto no da ningún error y
       deja el precio de la barra congelado en el de antes. */
    function armarEspia() {
      if (espia) {
        espia.disconnect();
        espia = null;
      }
      if (!panel) return;
      if (!fuentePrecio && !fuenteBoton) return;
      if (typeof window.MutationObserver !== "function") return;
      espia = new window.MutationObserver(copiar);
      espia.observe(panel, {
        childList: true, characterData: true, subtree: true,
        attributes: true, attributeFilter: ["disabled"]
      });
    }
    armarEspia();

    /* ── 6 · EL BOTÓN COMPRA, Y COMPRA PASÁNDOLE EL CLIC AL DEL PANEL ─
       Es todo el mecanismo, y cabe en una línea: boton.click(). El porqué
       largo está en snippets/ml-buybar.liquid, que hizo esto mismo el
       21/08/2026, y se resume en que el camino al carrito tiene que ser UNO.
       Montar aquí un formulario propio fue el fallo 4 del historial: el panel
       montaba el suyo, se saltaba el JavaScript de Horizon y el botón navegaba
       a /cart en vez de abrir el cajón. Pasando el clic, la variante marcada,
       la cantidad, el estado de agotado, la burbuja de la cabecera y el cajón
       salen todos de <product-form-component>, que es quien ya lo hace bien.

       AQUÍ SE DESTAPA EL BOTÓN, y solo aquí: lo hace pintarBotonVenta(), unas
       líneas más abajo. El Liquid lo pinta con hidden porque sin este cable no
       hace nada; si no hay panel —o si el panel no trae [data-ml-add]— se
       queda tapado, que es la verdad: en esa página no hay nada que comprar
       desde aquí. Un botón visible sin destinatario sería exactamente el
       control muerto que el hidden viene a evitar, y no daría ningún error que
       alguien pudiera ver. Es una función y no una línea suelta porque la
       respuesta puede cambiar sin recargar: ver mirarPanel().

       El disabled se comprueba en el momento del clic aunque copiar() ya lo
       haya puesto también en este botón: un botón deshabilitado no dispara
       click en ningún navegador serio, pero esta guarda cuesta una línea y
       cubre el hueco entre que carga el guion y llega el primer copiar(). Es
       la misma guarda, y por el mismo motivo, que la de ml-producto.js. */
    /* El cable se ata SIEMPRE que haya botón en la barra, y quien puede faltar
       —fuenteBoton— se pregunta DENTRO, en el momento del clic. Atarlo solo si
       el panel estaba al arrancar volvería a congelar la decisión, que es lo
       que mirarPanel() viene a deshacer: en el editor, el botón nuevo llega
       después. Lo que sigue tapado o destapado lo decide pintarBotonVenta(),
       que sí se vuelve a llamar. */
    if (cta) {
      atar(cta, "click", function () {
        if (!fuenteBoton) return;
        if (fuenteBoton.disabled) return;
        fuenteBoton.click();
      });
    }

    /* El porqué del hidden está arriba, en el comentario de la sección 6. */
    function pintarBotonVenta() {
      if (!cta) return;
      cta.hidden = !fuenteBoton;
    }
    pintarBotonVenta();

    /* LA CONFIRMACIÓN DE MÓVIL, copiada de assets/ml-producto.js porque el
       problema es el mismo: en escritorio al añadir se abre el cajón lateral y
       esta caja no se usa nunca; en móvil el cajón no se abre —lo apaga
       sincronizarCajon(), y el porqué medido está allí— y sin él no queda
       ninguna señal de que la línea ha entrado. Menos aún aquí: quien pulsa
       este botón está seis pantallas por debajo de la burbuja de la cabecera.

       Se cuelga del evento del carrito y no del clic, para que diga «Añadido»
       cuando de verdad se ha añadido y no cuando se ha pulsado: si la llamada
       falla, la barra se queda como estaba y el error lo cuenta el panel, que
       es de donde salió el envío.

       esMovil() se pregunta EN EL MOMENTO DEL EVENTO y no al arrancar, porque
       entre el arranque y el clic cabe un giro de pantalla.

       Vuelve sola a los cuatro segundos para poder añadir otra vez.

       ══════════════════════════════════════════════════════════════
       QUÉ SE LE PREGUNTA AL EVENTO, Y POR QUÉ NO ES «e.detail.action»
       ══════════════════════════════════════════════════════════════
       Hasta el 03/09/2026 la guarda decía

           if (e && e.detail && e.detail.action && e.detail.action !== "add")

       y no filtraba NADA. El contrato que publica Shopify dentro del propio
       tema —assets/standard-events.d.ts, el tipo CartLinesUpdatePayload— pone
       «action» EN LA RAÍZ del payload, y la clase base ShopifyStandardEvent
       hace Object.assign(this, payload), así que «action» acaba en la raíz
       del evento. «detail» es otra cosa: un campo OPCIONAL para datos propios
       del tema, y en este evento normalmente no existe. Medido el 03/09/2026
       con la forma real del evento: e.detail es undefined y «detail» ni
       siquiera está en el objeto. Así que la condición cortocircuitaba en el
       segundo término y no descartaba ningún evento.

       Consecuencia, medida en 390×844 con el botón de quitar de Horizon: el
       cliente QUITA una línea del cajón y esta barra le dice «Añadido · Ver
       cesta» durante cuatro segundos. El emisor es
       assets/component-cart-items.js, que despacha action «update» o
       «remove» por el mismo evento.

       Y ahora se pide «add» EN POSITIVO, no «distinto de add». Sin action no
       hay prueba de que se haya añadido nada, y el contrato la da siempre en
       este evento: si algún día dejara de darla, esta caja no se encendería
       nunca y N14, N26 y N27 se pondrían rojas. Un rojo se ve; una barra que
       miente, no.

       ══════════════════════════════════════════════════════════════
       Y EL FOCO, QUE SE CAÍA AL <body>
       ══════════════════════════════════════════════════════════════
       Esconder el botón esconde el elemento que tiene el foco, y el foco se
       va al <body>: quien compra con el teclado pierde el sitio y el
       siguiente tabulador vuelve a empezar por la cabecera. Medido el
       03/09/2026 en 760×800 sin táctil: antes BUTTON.ml-cbar__cta, después
       BODY.

       Se mueve al enlace «Ver la cesta», que es el único control que aparece
       en el sitio del que desaparece y es lo siguiente que hará quien acaba
       de añadir. Y se mueve SOLO SI EL BOTÓN TENÍA EL FOCO: no se le quita el
       foco a nadie que estuviera en otra parte de la página, que sería
       moverle el suelo por algo que no ha hecho.

       El orden importa y por eso no es el natural: se destapa la caja ANTES
       de tapar el botón, para que el foco salte de uno a otro sin pasar por
       el <body> ni un fotograma. A los cuatro segundos, el camino de vuelta:
       si el foco está dentro de la caja se devuelve al botón, otra vez
       destapándolo antes. Sin esa mitad, la vuelta dejaría el foco en el
       <body> igual que lo dejaba la ida. */
    var relojOk = null;
    var verCesta = ok ? ok.querySelector("a[href]") : null;
    if (ok && cta) {
      atar(document, "shopify:cart:lines-update", function (e) {
        /* fuenteBoton se pregunta aquí y no en la condición de fuera, por lo
           mismo que en el cable del clic: al arrancar puede no estar y en el
           editor puede llegar después. Sin panel no hay forma de añadir desde
           esta barra, así que tampoco hay nada que confirmar en ella. */
        if (!fuenteBoton) return;
        if (!esMovil()) return;
        if (!e) return;
        if (e.action !== "add") return;
        var teniaFoco = cta.contains(document.activeElement);
        ok.hidden = false;
        if (teniaFoco) {
          if (verCesta) verCesta.focus();
        }
        cta.hidden = true;
        window.clearTimeout(relojOk);
        relojOk = window.setTimeout(function () {
          var vuelve = ok.contains(document.activeElement);
          cta.hidden = false;
          if (vuelve) cta.focus();
          ok.hidden = true;
        }, 4000);
      });
    }

    /* ── ARRANQUE Y REDIMENSIONADO ───────────────────────────────────
       Se pinta antes de que llegue ningún registro. Es contrato del banco
       para la barra de compra y vale igual aquí: quien entra por un ancla y
       no ha movido la rueda ni una vez tiene que ver la barra bien puesta. */
    medirDesborde();
    armarCabecera();
    copiar();
    repintar();

    /* Al redimensionar cambia el alto de la ventana, y con él la altura a la
       que están puestos todos los cables: hay que volver a ponerlos. El
       pActual a −1 es lo que fuerza que avanzar() rearme en vez de salirse por
       la guarda del bucle. Se espera un poco porque al girar un móvil llegan
       varios avisos seguidos.

       El «load» es por las tipografías: hasta que no cargan, los rótulos miden
       otra cosa y el desborde se calcula sobre una lista que no es la
       definitiva. */
    var reloj = null;
    atar(window, "resize", function () {
      window.clearTimeout(reloj);
      reloj = window.setTimeout(function () {
        anchoRotulos = 0;
        medirDesborde();
        armarCabecera();
        pActual = -1;
        repintar();
      }, 120);
    });
    atar(window, "load", function () {
      medirRotulos();
      medirDesborde();
      pActual = -1;
      repintar();
    });

    /* La otra mitad de «la barra no se apaga debajo del foco». Sin esto, la
       barra se quedaría encendida hasta el siguiente aviso de scroll o de
       cable, y quien tabula sin tocar la rueda no genera ninguno de los dos.

       Se escucha en el documento y no en la barra porque lo que interesa es
       adónde ha ido el foco: cuando llega este aviso ya está en su destino,
       así que document.activeElement dice la verdad.

       Solo pintar(), no repintar(): entrar o salir del foco no mueve el
       scroll, así que ni el capítulo activo ni la línea de avance cambian, y
       llamar a avanzar() aquí rearmaría los cables sin motivo. */
    atar(document, "focusin", function () { pintar(); });

    /* ── Y LA OTRA DIRECCIÓN, QUE FALTABA ───────────────────────────────
       «focusin» cubre «el foco llega a algún sitio», y eso NO es lo mismo que
       «el foco sale de la barra». Cuando el foco se va al <body> —tocar un
       párrafo, tocar un hueco de la página, un blur()— no hay destino que
       enfocar y no se despacha ningún «focusin». Los observadores tampoco
       vuelven: sus estados no han cambiado y un observador solo avisa AL
       CAMBIAR. O sea que conFoco() dejaba la barra encendida el resto de la
       visita, con su botón de comprar fijo encima del pie y el bloque de
       capítulos ya fuera de la pantalla por arriba — que es exactamente lo
       que se retiró el 02/09/2026 al sacar el pie de las zonas.

       Medido el 06/09/2026 en /products/the-secret-brush a 390x844 con
       toques de verdad: con el foco en una parada y el documento en el fondo
       —el bloque de capítulos acabado en −408— la barra estaba {on:true,
       inert:false}, que es lo correcto; al tocar un párrafo del pie y soltar
       el foco al <body> se quedaba igual.

       SE VUELVE A PREGUNTAR EN UN setTimeout(0) Y NO EN EL PROPIO «focusout»
       porque durante el focusout el foco todavía no se ha movido:
       document.activeElement sigue diciendo el elemento que lo está
       perdiendo, así que conFoco() contestaría «sí» siempre. Un turno de
       reloj después el foco ya está donde vaya a quedarse —el <body>
       incluido— y la pregunta es la misma que contesta el «focusin» de
       arriba, solo que más tarde. Es la regla de recorrer las dos
       direcciones, la de N22 y la de N30.

       El cable se limita a los focusout que salen de la barra —«e.target» en
       un focusout es quien pierde el foco, y eso sí es fiable— para no montar
       un temporizador en cada cambio de foco de toda la página. Y el reloj se
       guarda para poder pararlo en mlDestruir(): un pintar() en vuelo
       repintaría encima del marcado recién devuelto. */
    var relojFoco = null;
    atar(document, "focusout", function (e) {
      if (!e || !e.target) return;
      if (!bar.contains(e.target)) return;
      window.clearTimeout(relojFoco);
      relojFoco = window.setTimeout(function () { pintar(); }, 0);
    });

    /* Primero se suelta todo lo que puede volver a escribir —el reloj del
       redimensionado, los cables, la banda, el espía del panel y el gancho
       que vuelve a preguntar por la otra barra—, y solo después se
       devuelve el marcado. Al revés, un aviso en vuelo podría repintar encima
       de lo recién devuelto. mlRevisar se quita y no se deja apuntando a un
       repintar() muerto: el oyente del final del archivo recorre el documento
       entero, y una barra destruida que todavía siguiera en él se pintaría
       sola. */
    bar.mlDestruir = function () {
      window.clearTimeout(reloj);
      window.clearTimeout(relojOk);
      window.clearTimeout(relojFoco);
      soltarCables();
      if (cableCabecera) cableCabecera.disconnect();
      if (cableAnticipo) cableAnticipo.disconnect();
      if (cableBoton) cableBoton.disconnect();
      obsBanda.disconnect();
      if (espia) espia.disconnect();
      bar.mlRevisar = null;
      atar.soltar();

      if (previo.inert) bar.setAttribute("inert", "");
      else bar.removeAttribute("inert");
      /* El botón vuelve a estar tapado y la confirmación también: los dos los
         destapa este archivo, así que los dos tiene que volver a tapar. */
      if (cta) cta.hidden = previo.ctaTapado;
      if (ok) ok.hidden = previo.okTapado;
      bar.classList.toggle("is-on", previo.encendida);
      if (listaEl) listaEl.classList.toggle("is-scroll", previo.desborde);
      if (linea) linea.style.width = previo.ancho || "";
      if (idx && previo.numeral !== null) idx.textContent = previo.numeral;
      if (previo.total) previo.total.nodo.nodeValue = previo.total.texto;
      for (var n = 0; n < enlaces.length; n++) {
        var antes = previo.paradas[n];
        enlaces[n].classList.toggle("is-active", antes.activa);
        if (antes.actual === null) enlaces[n].removeAttribute("aria-current");
        else enlaces[n].setAttribute("aria-current", antes.actual);
      }
    };
  }

  /* ── ARRANQUE POR INSTANCIA · lo de dentro de root, y root ──── */
  function cada(root, sel, fn) {
    if (root.matches && root.matches(sel)) fn(root);
    lista(root.querySelectorAll(sel)).forEach(fn);
  }
  function init(root) {
    var base = root || document;
    if (!base || !base.querySelectorAll) return;
    cada(base, "[data-ml-cbar]", iniciarBarra);
  }
  function destruir(root) {
    if (!root || !root.querySelectorAll) return;
    cada(root, "[data-ml-cbar]", function (el) {
      if (typeof el.mlDestruir === "function") el.mlDestruir();
      el.mlIniciado = false;
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { init(document); });
  } else { init(document); }

  /* Las barras que YA estaban corriendo vuelven a preguntar si la ficha monta
     ahora la barra de compra. Se hace aquí y no dentro de iniciarBarra porque
     quien aparece o desaparece es OTRA sección —la del hero, que es la que
     pinta [data-ml-buybar]— y su aviso no pasa por la barra de capítulos: el
     init() de la línea de al lado solo mira dentro de e.target, y ahí no hay
     ninguna [data-ml-cbar]. El porqué entero, y lo que esto no cubre, están
     donde se declara la bandera. */
  function revisar() {
    lista(document.querySelectorAll("[data-ml-cbar]")).forEach(function (el) {
      if (typeof el.mlRevisar === "function") el.mlRevisar();
    });
  }

  /* En el editor la sección se sustituye sin recargar. */
  document.addEventListener("shopify:section:load", function (e) {
    init(e.target || document);
    revisar();
  });
  document.addEventListener("shopify:section:unload", function (e) { destruir(e.target); });

  window.MLCapitulos = { init: init, destroy: destruir };
})();
